import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const testimonials = [
  {
    name: "Laura M.",
    city: "San Angelo, TX",
    text:
      "On time, polite, and my kitchen windows look brand new. The tracks being included is the detail nobody else offers.",
  },
  {
    name: "David R.",
    city: "Wall, TX",
    text:
      "Straight-up pricing, no upsell. They counted my windows, gave me a number, and stuck to it. Happy to have found them.",
  },
  {
    name: "Marcos T.",
    city: "San Angelo storefront",
    text:
      "They clean our storefront every other week before we open. Professional crew, insured, and the glass looks sharp for customers all day.",
  },
];

export default function Testimonials() {
  return (
    <section
      className="bg-[#F9F9F6] py-24 md:py-32 border-t border-black/5"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-14 max-w-2xl">
          <div className="text-xs uppercase tracking-[0.25em] font-semibold text-[#1A365D] mb-4">
            What neighbors are saying
          </div>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-[#111827] leading-tight">
            Trusted in every
            <br />
            <span className="italic text-[#1A365D]">window it touches.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((t, i) => (
            <motion.article
              key={t.name}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="relative rounded-3xl bg-white p-8 border border-black/5 shadow-[0_8px_30px_rgba(0,0,0,0.04)]"
            >
              <Quote className="h-6 w-6 text-[#1A365D]/30 mb-4" />
              <p className="font-serif text-xl md:text-2xl text-[#111827] leading-snug">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-6 pt-6 border-t border-black/5 flex items-center justify-between text-sm">
                <span className="font-medium text-[#111827]">{t.name}</span>
                <span className="text-[#4B5563]">{t.city}</span>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
